import { mapGetters, mapMutations, mapActions} from 'vuex';
import * as moment from 'moment/moment'
import datetime from 'vuejs-datetimepicker'
import lotProductPopup from './lot-product/index.vue'
import removeConfirm from '@/components/popups/remove-confirm/index.vue'
import writeOffConfirm from '@/components/popups/writeOffConfirm/index.vue'


export default {
    props: ['popupType'],
    components: {
        datetime,
        lotProductPopup,
        removeConfirm,
        writeOffConfirm,
    },
    data() {
        return {
            form: {
                provisioner:  null,
                date: new Date(),
                warehouse: null,
                products: []
            },
            showLotPopup: false,
            showRemoveConfirm: false,
            showWriteOffConfirm: false,
            writeOffPending: false,
            selectedItem: null,
            // статичні fieldDefs: підписи через labelKey, label обчислюється в computed
            fieldDefs: [
                {
                    key: 'product.id',
                    label: 'id',
                },
                {
                    key: 'product.title',
                    labelKey: 'popupLot.product',
                },
                {
                    key: 'article',
                    labelKey: 'popupLot.article',
                },
                {
                    key: 'buy_price',
                    labelKey: 'popupLot.price_uah',
                },
                {
                    key: 'buy_price_usd',
                    labelKey: 'popupLot.price_usd',
                },
                {
                    key: 'buy_quantity',
                    labelKey: 'popupLot.quantity',
                },
                {
                    key: 'less_quantity',
                    labelKey: 'popupLot.remain',
                },
                {
                    key: 'total',
                    labelKey: 'popupLot.total_uah',
                },
                {
                    key: 'total_usd',
                    labelKey: 'popupLot.total_usd',
                },
                {
                    key: 'newProduct',
                    label: '',
                },
            ],
            removeItem: null,
        }
    },
    computed: {
        // реактивні підписи полів таблиці (залежать від локалі)
        fields() {
            return this.fieldDefs.map(f => f.labelKey ? { ...f, label: this.$t(f.labelKey) } : f);
        },
        ...mapGetters({
            lot: 'lot/lot',
            warehouses: 'warehouse/warehouses',
            provisioners: 'warehouse/provisioners',
            products: 'catalog/products',
            product: 'catalog/product'
        }),
        items() {
            return this.form.products.map( el => {
                console.log(el)
                return {
                    ...el,
                    article: el.product.sku,
                    buy_price: Math.ceil(Number(el.buy_price) * 100) / 100,
                    buy_price_usd: Math.ceil(Number(el.buy_price_usd) * 100) / 100,
                    total: Math.ceil(Number(+el.buy_price*el.buy_quantity) * 100) / 100,
                    total_usd: Math.ceil(Number(+el.buy_price_usd*el.buy_quantity) * 100) / 100,
                }
            })
        }
    },
    created() {
      this.getWarehouses()
      this.getProvisioners()
      this.getProducts()
    },
    watch:{
        lot(e){
                this.form.provisioner = e.provisioner_id;
                this.form.warehouse = e.warehouse_id;
                this.form.date = moment(e.updated_at ? e.updated_at : e.created_at).format('YYYY-MM-DD HH:mm');
                this.form.products = e.lot_products;
                // console.log(this.form.products)
        },
        item(e) {
            this.showProduct(e)
        },
    },
    methods: {
        changeProductItem(){
          this.addProductClick();
        },
        prepareRemoveItem(item){
            this.removeItem = item;
          this.showRemoveConfirm = true
        },
        appendProduct(payload) {
            console.log('payload - ', payload);
            this.form.products.push(payload)
            this.showLotPopup = false
        },
        addProductClick() {
            this.showLotPopup = true;
        },
        closePopup() {
            this.$emit('closePopup')
        },
        sendLot() {
            const data = {
                provisioner_id: this.form.provisioner,
                warehouse_id: this.form.warehouse,
                lot_products: this.form.products.map( item => {
                    return {
                        product_id: item.product_id,
                        buy_price : +item.buy_price || null,
                        buy_price_usd : +item.buy_price_usd || null,
                        buy_quantity: +item.buy_quantity,
                        less_quantity: +item.less_quantity,
                        minimum: +item.minimum,
                        newProduct: item.newProduct ? item.newProduct : false
                    }
                })
            }
            if(this.lot){
                const payload = {
                    id: this.lot.id,
                    data: data
                }
                this.$emit('changeLot', payload)
            }else{
                this.$emit('sendLot', data)
            }
        },
        selectItem(item) {
            this.selectedItem = item[0]

        },
        deleteLotProduct() {
            const index = this.items.indexOf(this.removeItem);
            this.items.splice(index, 1);
            this.form.products.splice(index, 1);
            this.showRemoveConfirm = false;
        },
        confirmWriteOff(form){
            if (this.writeOffPending) {
                return;
            }
            // Explicit-списання адресоване рядку збереженої партії: без lot_id
            // бекенд перейшов би в глобальний FIFO по всіх партіях товару.
            if (!this.selectedItem || !this.selectedItem.lot_id) {
                this.$toasted.error(this.$t('popupWriteOff.error_unsaved_lot'), {
                    duration: 3000
                });
                return;
            }
            this.writeOffPending = true;
            const lotId = this.selectedItem.lot_id;
            const payload = {
                lot_id: lotId,
                product_id: this.selectedItem.product_id,
                quantity: Number(form.quantity),
                reason: form.reason,
            }
            this.sendWriteOff(payload).then((result) => {
                if (result.status) {
                    this.showWriteOffConfirm = false;
                    this.showLot(lotId);
                    return;
                }
                this.$toasted.error(this.writeOffErrorMessage(result.data), {
                    duration: 3000
                });
            }).catch((e) => {
                this.$toasted.error(this.writeOffErrorMessage(e.response ? e.response.data : null), {
                    duration: 3000
                });
            }).finally(() => {
                this.writeOffPending = false;
            });
        },
        writeOffErrorMessage(data) {
            const messages = {
                'Insufficient free stock for write-off.': 'popupWriteOff.error_insufficient',
                'Product lot is missing for write-off.': 'popupWriteOff.error_lot_missing',
                'Lot has several product rows; explicit write-off is ambiguous.': 'popupWriteOff.error_ambiguous',
                'Invalid write-off quantity.': 'popupWriteOff.error_quantity',
            };
            if (data && data.errors) {
                const key = Object.keys(data.errors)[0];
                if (key && Array.isArray(data.errors[key]) && data.errors[key].length) {
                    const message = data.errors[key][0];
                    return messages[message] ? this.$t(messages[message]) : message;
                }
            }
            if (data && data.message && messages[data.message]) {
                return this.$t(messages[data.message]);
            }
            return data && data.message ? data.message : this.$t('popupWriteOff.error_generic');
        },
        ...mapActions({
            getWarehouses: 'warehouse/getWarehouses' ,
            getProvisioners: 'warehouse/getProvisioners',
            getProducts: 'catalog/getProducts',
            showProduct: 'catalog/showProduct',
            removeLotProduct: 'lot/removeLotProduct',
            sendWriteOff: 'lot/sendWriteOff',
            showLot: 'lot/showLot',

        }),
        ...mapMutations({
            changeLot: 'lot/changeLot',
            changeProduct: 'catalog/changeProduct'
        })
    },
    destroyed() {
        this.changeLot(null);
        this.changeProduct(null)
    }
}
